import { IServiceRequestTicketDto } from 'api/odata/generated/entities/IServiceRequestTicketDto';

export function getServiceRequestTicketTitle(item: IServiceRequestTicketDto) {
  return `#${item.ServiceRequestId} - ${item.ServiceRequest.CreatedFor?.Name}`;
}
